{
  "id": "campaign-150",
  "name": "Clover Meadow",
  "seed": "campaign:150",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "............mm......",
    ".....T..#....m......",
    "..........#..h......",
    "....h.........T.....",
    "...............T..m.",
    ".....T.....T.....mmm",
    "..x..............xm.",
    ".........h..........",
    "...T...h.....h.#....",
    ".....T..............",
    "............#.......",
    ".,,,................",
    "........h...#....Y..",
    ".....T..............",
    "....................",
    "...x................",
    ".#.......Y..........",
    ".................x..",
    "..*.................",
    "h..*x..............S"
  ],
  "critters": [
    {
      "kind": "stag",
      "x": 4,
      "y": 2
    },
    {
      "kind": "deer",
      "x": 10,
      "y": 10
    },
    {
      "kind": "deer",
      "x": 10,
      "y": 9
    },
    {
      "kind": "deer",
      "x": 9,
      "y": 5
    },
    {
      "kind": "deer",
      "x": 9,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 3,
      "y": 2
    },
    {
      "kind": "gas",
      "x": 8,
      "y": 16
    },
    {
      "kind": "gas",
      "x": 15,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 12,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 17
    },
    {
      "kind": "coin",
      "x": 19,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 16
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 14
    }
  ],
  "hills": [
    {
      "x": 1,
      "y": 6,
      "w": 7,
      "h": 7
    },
    {
      "x": 10,
      "y": 2,
      "w": 7,
      "h": 7
    }
  ],
  "generatorVersion": 3,
  "level": 150,
  "biome": "meadow",
  "par": {
    "reel": 14136,
    "push": 12322,
    "selfPropelled": 11169,
    "tractor": 9531,
    "zeroTurn": 8127,
    "fairway": 4690
  },
  "goldTime": {
    "reel": 14127,
    "push": 12244,
    "selfPropelled": 11169,
    "tractor": 9341,
    "zeroTurn": 8040,
    "fairway": 4647
  },
  "routeTries": {
    "par": {
      "reel": 18,
      "push": 0,
      "selfPropelled": 8,
      "tractor": 0,
      "zeroTurn": 13,
      "fairway": 9
    },
    "gold": {
      "reel": 25,
      "push": 25,
      "selfPropelled": 8,
      "tractor": 25,
      "zeroTurn": 46,
      "fairway": 31
    }
  }
}
